import { useCallback, useEffect, useState } from 'react';

const useShare = () => {
  const [copiedToClipboard, setCopiedToClipboard] = useState(false);

  useEffect(() => {
    if (copiedToClipboard) {
      const timer = setTimeout(() => {
        setCopiedToClipboard(false);
      }, 4000);
      return () => clearTimeout(timer);
    }
  }, [copiedToClipboard]);

  const share = useCallback(async ({ title, text, url }) => {
    if (navigator.canShare && navigator.canShare({ title, text, url })) {
      try {
        await navigator.share({ title, text, url });
      } catch (error) {
        console.error('Sharing attempt failed:', error.message);
      }
    } else {
      try {
        await navigator.clipboard.writeText(url || text);
        setCopiedToClipboard(true);
      } catch (error) {
        console.error('Could not copy to clipboard', error.message);
      }
    }
  }, []);

  return { share, copiedToClipboard };
};

export default useShare;
